module.exports = __webpack_public_path__ + "dde8e698029c4af548570d5dac2b3191.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/Gifbit_Grey@2x.png
// module id = 111
// module chunks = 0